import PropTypes from 'prop-types';

import { companyStatusEnum } from 'modules/companyActivation/enums';

import {
  CompanyHeaderWrapper,
  CompanyHeaderFilterWrapper,
  CompanyHeaderFilterItemWrapper,
  CompanyHeaderFilterItem,
} from './CompanyActivationHeader.style';

const CompanyActivationHeader = ({ selectedStatusFilter, handleCompanyStatusFilterClick }) => {
  const companyStatusFilterList = [
    { key: 0, name: 'All Companies' },
    ...Object.keys(companyStatusEnum)
      .filter(
        key =>
          typeof companyStatusEnum[key] === 'string' || typeof companyStatusEnum[key] === 'number',
      )
      .map(key => ({
        key: companyStatusEnum[key],
        name: key,
      })),
  ];

  return (
    <CompanyHeaderWrapper>
      <CompanyHeaderFilterWrapper>
        {companyStatusFilterList.map(companyFilterItem => {
          const isFilterSelected = companyFilterItem.key === selectedStatusFilter;

          return (
            <CompanyHeaderFilterItemWrapper
              key={companyFilterItem.key}
              selected={isFilterSelected}
              onClick={() => handleCompanyStatusFilterClick(companyFilterItem.key)}
            >
              <CompanyHeaderFilterItem>{companyFilterItem.name}</CompanyHeaderFilterItem>
            </CompanyHeaderFilterItemWrapper>
          );
        })}
      </CompanyHeaderFilterWrapper>
    </CompanyHeaderWrapper>
  );
};

CompanyActivationHeader.propTypes = {
  selectedStatusFilter: PropTypes.number.isRequired,
  handleCompanyStatusFilterClick: PropTypes.func.isRequired,
};

export default CompanyActivationHeader;
